import React, { PureComponent } from 'react'
import { Row, Panel } from 'react-bootstrap'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import { Field } from 'redux-form'
import { dossierTypes as dossierTypesConstant } from '../../../constants/dossier/common/dossierTypes'
import { getFieldsPermisions } from '../../../util/permisionFunctions'
import { compareObjects } from '../../../util/utils'
import { permissions } from '../../../constants/backendIds'
import CustomFields from '../../commons/customFields/CustomFields'

class OtherData extends PureComponent {
  constructor () {
    super()
    this.state = {
      open: false,
      fieldsConfiguration: {
        additionalClauses: null,
        previousUsageId: null,
        laterUseId: null,
        vehicleTypeId: null,
        activityClient: null,
        activityBuyer: null,
        paymentMethodPurchaseId: null,
        ivaTypeId: null
      }
    }
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  UNSAFE_componentWillMount () {
    this.initializePermisions(this.props)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.open) {
      this.setState({ open: true })
    }

    if (nextProps.dossierId && !compareObjects(this.props.componentConfiguration || {}, nextProps.componentConfiguration, true)) {
      this.initializePermisions(nextProps)
    }
  }

  componentDidMount () {
    this.fetchInitialData()
  }

  fetchInitialData () {
    if (this.props.isOtherDataLoaded === false) {
      return new Promise((resolve, reject) => {
        this.props.handleToUpdateComponent(this.props)
        if (this.props.dossierType === dossierTypesConstant.sales) {
          return this.props.actions.fetchSalesOtherData(this.props.dossierId, resolve, reject, this.props.pristine)
        } else if (this.props.dossierType === dossierTypesConstant.purchase) {
          return this.props.actions.fetchPurchaseOtherData(this.props.dossierId, resolve, reject, this.props.pristine)
        }
      })
    }
  }

  fetchSalesDossierPromiseOtherData () {
    if (this.state.open) {
      this.props.actions.setActiveSection(false)
    }
    this.setState({
      open: !this.state.open
    })
    if (this.props.isOtherDataLoaded === false) {
      return new Promise((resolve, reject) => {
        this.props.handleToUpdateComponent(this.props)
        if (this.props.dossierType === dossierTypesConstant.sales) {
          return this.props.actions.fetchSalesOtherData(this.props.dossierId, resolve, reject, this.props.pristine)
        } else if (this.props.dossierType === dossierTypesConstant.purchase) {
          return this.props.actions.fetchPurchaseOtherData(this.props.dossierId, resolve, reject, this.props.pristine)
        }
      })
    }
  }

  render () {
    const {
      t, dossierType, readOnlyFields, showEconomicPlan, customFields,
      combos: {
        ivaTypeCombo, paymentMethodPurchase, laterUseCombo, vehicleType, previousUsageCombo, activityClientCombo
        , activityBuyerCombo
      }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.'

    return (
      <div className={dossierType === dossierTypesConstant.purchase ? ('other-data-panel dossier-panel') : 'dossier-panel'}>
        <div className="header-panel" onClick={this.fetchSalesDossierPromiseOtherData.bind(this)}>
          <div className="name-wrapper">
            <i className="ico-comment"/>
            <h4>{t(`${tKey}OTHER_DATA.TITLE_PANEL`)}</h4>
          </div>
          <i className={this.state.open ? 'ico-arrow-black-up' : 'ico-arrow-black-down'}/>
        </div>
        <Panel expanded={this.state.open} onToggle={() => {}}>
          <Panel.Collapse>
            {
              dossierType === dossierTypesConstant.purchase ? (
                <Row>
                  {this.state.fieldsConfiguration.additionalClauses.permission !== permissions.hidden && (<Field
                    id="additionalClauses"
                    name="dossierCompleteOtherDataComponent.additionalClauses"
                    colSm={4}
                    controlLabel={t(`${tKey}OTHER_DATA.ADDITIONAL_CLAUSES`)}
                    placeholder={t(`${tKey}OTHER_DATA.ADDITIONAL_CLAUSES`)}
                    component={InputText}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.additionalClauses.permission !== permissions.editable}
                    forceControlLabelInOneLine={true}
                  />)}
                  {this.state.fieldsConfiguration.previousUsageId.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="previousUsageId"
                    name="dossierCompleteOtherDataComponent.previousUsageId"
                    controlLabel={t(`${tKey}OTHER_DATA.PREVIOUS_USAGE`)}
                    placeholder={t(`${tKey}OTHER_DATA.PREVIOUS_USAGE`)}
                    component={InputSelect}
                    options={previousUsageCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={readOnlyFields || this.state.fieldsConfiguration.previousUsageId.permission !== permissions.editable}
                  />)}
                  {this.state.fieldsConfiguration.laterUseId.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="laterUseId"
                    name="dossierCompleteOtherDataComponent.laterUseId"
                    controlLabel={t(`${tKey}OTHER_DATA.LATER_USE`)}
                    placeholder={t(`${tKey}OTHER_DATA.LATER_USE`)}
                    component={InputSelect}
                    options={laterUseCombo}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.laterUseId.permission !== permissions.editable}
                    valueKey="id"
                    labelKey="value"
                  />)}
                  {this.state.fieldsConfiguration.vehicleTypeId.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="vehicleTypeId"
                    name="dossierCompleteOtherDataComponent.vehicleTypeId"
                    controlLabel={t(`${tKey}OTHER_DATA.VEHICLE_TYPE`)}
                    placeholder={t(`${tKey}OTHER_DATA.VEHICLE_TYPE`)}
                    component={InputSelect}
                    options={vehicleType}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.vehicleTypeId.permission !== permissions.editable}
                    valueKey="id"
                    labelKey="value"
                  />)}
                  {this.state.fieldsConfiguration.activityClient.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="activityClient"
                    name="dossierCompleteOtherDataComponent.activityClientId"
                    controlLabel={t(`${tKey}OTHER_DATA.ACTIVITY_CLIENT`)}
                    placeholder={t(`${tKey}OTHER_DATA.ACTIVITY_CLIENT`)}
                    component={InputSelect}
                    options={activityClientCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={readOnlyFields || this.state.fieldsConfiguration.activityClient.permission !== permissions.editable}
                  />)}
                  {this.state.fieldsConfiguration.activityBuyer.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="activityBuyer"
                    name="dossierCompleteOtherDataComponent.activityBuyerId"
                    controlLabel={t(`${tKey}OTHER_DATA.ACTIVITY_BUYER`)}
                    placeholder={t(`${tKey}OTHER_DATA.ACTIVITY_BUYER`)}
                    component={InputSelect}
                    options={activityBuyerCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={readOnlyFields || this.state.fieldsConfiguration.activityBuyer.permission !== permissions.editable}
                  />)}
                  {this.state.fieldsConfiguration.paymentMethodPurchaseId.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="paymentMethodPurchaseId"
                    name="dossierCompleteOtherDataComponent.paymentMethodPurchaseId"
                    controlLabel={t(`${tKey}OTHER_DATA.PAYMENT_METHOD`)}
                    placeholder={t(`${tKey}OTHER_DATA.PAYMENT_METHOD`)}
                    component={InputSelect}
                    options={paymentMethodPurchase}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.paymentMethodPurchaseId.permission !== permissions.editable}
                    valueKey="id"
                    labelKey="value"
                  />)}
                  {this.state.fieldsConfiguration.ivaTypeId.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="ivaTypeId"
                    name="dossierCompleteOtherDataComponent.ivaTypeId"
                    controlLabel={t(`${tKey}OTHER_DATA.IVA_TYPE_ID`)}
                    placeholder={t(`${tKey}OTHER_DATA.IVA_TYPE_ID`)}
                    component={InputSelect}
                    options={ivaTypeCombo}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.ivaTypeId.permission !== permissions.editable}
                    valueKey="id"
                    labelKey="value"
                  />)}
                </Row>
              ) : (dossierType === dossierTypesConstant.sales ? (
                <Row>
                  {this.state.fieldsConfiguration.additionalClauses.permission !== permissions.hidden && (<Field
                    id="additionalClauses"
                    name="dossierCompleteOtherDataComponent.additionalClauses"
                    colSm={4}
                    controlLabel={t(`${tKey}OTHER_DATA.ADDITIONAL_CLAUSES`)}
                    placeholder={t(`${tKey}OTHER_DATA.ADDITIONAL_CLAUSES`)}
                    component={InputText}
                    forceControlLabelInOneLine={true}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.additionalClauses.permission !== permissions.editable}
                  />)}
                  {this.state.fieldsConfiguration.previousUsageId.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="previousUsageId"
                    name="dossierCompleteOtherDataComponent.previousUsageId"
                    controlLabel={t(`${tKey}OTHER_DATA.PREVIOUS_USAGE`)}
                    placeholder={t(`${tKey}OTHER_DATA.PREVIOUS_USAGE`)}
                    component={InputSelect}
                    options={previousUsageCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={readOnlyFields || this.state.fieldsConfiguration.previousUsageId.permission !== permissions.editable}
                  />)}
                  {this.state.fieldsConfiguration.laterUseId.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="laterUseId"
                    name="dossierCompleteOtherDataComponent.laterUseId"
                    controlLabel={t(`${tKey}OTHER_DATA.LATER_USE`)}
                    placeholder={t(`${tKey}OTHER_DATA.LATER_USE`)}
                    component={InputSelect}
                    options={laterUseCombo}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.laterUseId.permission !== permissions.editable}
                    valueKey="id"
                    labelKey="value"
                  />)}
                  {this.state.fieldsConfiguration.vehicleTypeId.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="vehicleTypeId"
                    name="dossierCompleteOtherDataComponent.vehicleTypeId"
                    controlLabel={t(`${tKey}OTHER_DATA.VEHICLE_TYPE`)}
                    placeholder={t(`${tKey}OTHER_DATA.VEHICLE_TYPE`)}
                    component={InputSelect}
                    options={vehicleType}
                    disabled={readOnlyFields || this.state.fieldsConfiguration.vehicleTypeId.permission !== permissions.editable}
                    valueKey="id"
                    labelKey="value"
                  />)}
                  {this.state.fieldsConfiguration.activityClient.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="activityClient"
                    name="dossierCompleteOtherDataComponent.activityClientId"
                    controlLabel={t(`${tKey}OTHER_DATA.ACTIVITY_CLIENT`)}
                    placeholder={t(`${tKey}OTHER_DATA.ACTIVITY_CLIENT`)}
                    component={InputSelect}
                    options={activityClientCombo}
                    defaultValueEntityType={this.state.defaultActivityClientId}
                    onChange={value => this.setState({ defaultActivityClientId: value })}
                    valueKey="id"
                    labelKey="value"
                    disabled={readOnlyFields || this.state.fieldsConfiguration.activityClient.permission !== permissions.editable}
                  />)}
                  {this.state.fieldsConfiguration.activityBuyer.permission !== permissions.hidden && (<Field
                    colSm={4}
                    id="activityBuyer"
                    name="dossierCompleteOtherDataComponent.activityBuyerId"
                    controlLabel={t(`${tKey}OTHER_DATA.ACTIVITY_BUYER`)}
                    placeholder={t(`${tKey}OTHER_DATA.ACTIVITY_BUYER`)}
                    component={InputSelect}
                    options={activityBuyerCombo}
                    valueKey="id"
                    labelKey="value"
                    disabled={readOnlyFields || this.state.fieldsConfiguration.activityBuyer.permission !== permissions.editable}
                  />)}
                  {!showEconomicPlan && this.state.fieldsConfiguration.ivaTypeId.permission !== permissions.hidden && (
                    <Field
                      colSm={4}
                      id="ivaTypeId"
                      name="dossierCompleteOtherDataComponent.ivaTypeId"
                      controlLabel={t(`${tKey}OTHER_DATA.IVA_TYPE_ID`)}
                      placeholder={t(`${tKey}OTHER_DATA.IVA_TYPE_ID`)}
                      component={InputSelect}
                      options={ivaTypeCombo}
                      disabled={readOnlyFields || this.state.fieldsConfiguration.ivaTypeId.permission !== permissions.editable}
                      valueKey="id"
                      labelKey="value"
                    />
                  )}
                </Row>
              ) : null
              )
            }
            <CustomFields customFields={customFields} readOnlyFields={readOnlyFields} />
          </Panel.Collapse>
        </Panel>
      </div>
    )
  }
}
export default OtherData
